'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z' });

var BurstMode = function BurstMode(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

BurstMode = (0, _pure2.default)(BurstMode);
BurstMode.muiName = 'SvgIcon';

exports.default = BurstMode;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/BurstMode.js
// module id = 2210
// module chunks = 0